// Taken from https://github.com/happyDemon/vue-echo/blob/master/vue-echo.js

import Echo from "laravel-echo";

export default {
	install( Vue, options ) {
		if ( !options ) {
			throw new Error( "Echo cannot locate options" );
		}

		if ( typeof options !== "object" ) {
			throw new Error( "Cannot initiate options" );
		}

		if ( typeof options.socketId == "function" ) {
			Vue.prototype.$echo = options;
		} else {
			Vue.prototype.$echo = new Echo( options );
		}

		Vue.mixin( {
			created() {
				const channel = this.$options.channel;

				if ( channel ) {
					if ( channel.startsWith( "private:" ) ) {
						this.channel = this.$echo.private( channel.replace( "private:", "" ) );
					} else if ( channel.startsWith( "presence:" ) ) {
						this.channel = this.$echo.join( channel.replace( "presence:", "" ) );
					} else {
						this.channel = this.$echo.channel( channel );
					}

					const events = this.$options.echo;

					if ( events ) {
						Object.keys( events ).forEach( function( key ) {

							// Bind the VM as second parameter
							this.channel.listen( key, payload => {
								events[key]( payload, this );
							} );
						}, this );
					}
				}
			},
			beforeDestroy() {
				if ( this.$options.channel ) {
					this.channel.unsubscribe();
				}
			}
		} );
	}
};
